import classNames from 'classnames';

import style from 'styles/components/messageCenter/PauseMessage';
import bannerTacos from 'images/banner-tacos.png';

const PauseMessage = ({ actionText, actionFunction, subheading, heading }) => {
  const dataTrack = { 'data-fb-track-event': 'ReactivateAccount', 'data-fb-track-custom': 'true' };

  const buttonClass = 'btn btnGreen btnOutlined bp2:min-w-48';

  return (
    <div className="bg-green-100">
      <div
        className={classNames(
          'flex',
          'justify-between',
          'bp2:pl-4',
          'bp2:pr-24',
          'bp2:p-4',
          'bp2:py-0',
          style.banner
        )}
      >
        <div className={classNames('flex', style.textAndImage)}>
          <img
            className={classNames(style.tacoImage, 'ml-10', 'max-h-24')}
            src={bannerTacos}
            alt="Banner Tacos"
          />
          <div className={classNames(style.textContainer)}>
            <p className={classNames(style.heading, 'font-bold mb-0 h4')}>{heading}</p>
            <p className={classNames(style.description, 'font-normal text-left')}>{subheading}</p>
          </div>
        </div>
        <div className="flex">
          <button
            onClick={actionFunction}
            className={classNames(style.buttonReactivate, buttonClass, 'w-full')}
            {...dataTrack}
          >
            {actionText}
          </button>
        </div>
      </div>
    </div>
  );
};

PauseMessage.propTypes = {
  actionFunction: PropTypes.func.isRequired,
  actionText: PropTypes.string,
  subheading: PropTypes.string,
  heading: PropTypes.string.isRequired,
};

export default PauseMessage;
